export default {
	AGENDA: "agenda",
	TEAM_GOALS: "team-goals",
	COMMITMENTS: "commitments",
	PAST_MEETINGS: "past-meetings",
	DEFAULT: "agenda",
};



// WEBPACK FOOTER //
// ./src/constants/Schedule/MeetingTabs.js